import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://rubispuvghopnhtccrcb.supabase.co'
const supabaseAnonKey = 'sb_publishable_ZUbvnLbX6UVqGS6zHiuY9w_Khml_uqS'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)